import { render } from "./Writing.vue?vue&type=template&id=7206e42b"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"

import "./Writing.vue?vue&type=style&index=0&id=7206e42b&lang=scss"
script.render = render

export default script